<template>
  <div>
    <div class="relative z-[100]" aria-labelledby="dialog-title" role="dialog" aria-modal="true" v-if="isOpen">
      <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>

      <div class="fixed inset-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
            <div>
              <slot name="body" />
            </div>
            <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import { defineModel } from 'vue';

const isOpen = defineModel();
</script>
